import React from 'react';
import Icon from './Icon';

export default class Close extends Icon {
  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        fill="currentColor"
        d="M10.133 7.791l4.64-4.64a1.656 1.656 0 0 1 2.342 2.343l-4.64 4.64 4.64 4.639a1.656 1.656 0 0 1-2.342 2.342l-4.64-4.64-4.639 4.64a1.656 1.656 0 1 1-2.342-2.342l4.64-4.64-4.64-4.639a1.656 1.656 0 0 1 2.342-2.342l4.64 4.64z"
      />
    </svg>
  );
}
